import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DeviceContextInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Normaliza URLs com possíveis barras duplas acidentais (mantendo https://)
    const cleanedUrl = request.url.replace(/([^:]\/)\/+/g, '$1');

    // Clona a requisição adicionando o header de contexto
    const secureReq = request.clone({
      url: cleanedUrl,
      headers: request.headers.set('X-Device-Context', 'asap_authorized_access')
    });

    return next.handle(secureReq);
  }
}
